import { render, staticRenderFns } from "./AzulRespostas.vue?vue&type=template&id=330d6e46&scoped=true"
import script from "./AzulRespostas.vue?vue&type=script&lang=js"
export * from "./AzulRespostas.vue?vue&type=script&lang=js"
import style0 from "../PendenciesDetail/styles.scss?vue&type=style&index=0&id=330d6e46&prod&scoped=true&lang=scss&external"
import style1 from "./AzulRespostas.vue?vue&type=style&index=1&id=330d6e46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d6e46",
  null
  
)

export default component.exports